function cookieDomain() {
	var host = window.location.hostname.split('.');
	return '.' + host[host.length - 2] + '.' + host[host.length - 1];
}

export default {
	domain: cookieDomain(),
	secure: (window.location.protocol === 'https:') ? true : false
}